import { render, staticRenderFns } from "./opinionSummary.vue?vue&type=template&id=f545e5f0&scoped=true"
import script from "./opinionSummary.vue?vue&type=script&lang=js"
export * from "./opinionSummary.vue?vue&type=script&lang=js"
import style0 from "./opinionSummary.vue?vue&type=style&index=0&id=f545e5f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f545e5f0",
  null
  
)

export default component.exports